import React from "react";
import { WizTableForm } from '@/containers/common'
import { mergeColumns } from '../../utils';

const user = WizTableForm.Config.user(this, { apiParams: { state: 1 } })
const path = WizTableForm.Config.path(this, { apiParams: { state: 2 } })
const organization = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })

//配置项
const componentName = "reportConfig";//reportConfig

function columns(reportConfigName) {
  const columns = [
    {
      title: "报表名称",
      name: "reportConfigName",
      searchItem: {
        //type: 'custom',
        formatInit: () => reportConfigName,
        disabled: true
      },
    },
  ];
  return mergeColumns.call(this, columns,[])
}

function templateConfig(reportConfigDetaiInfo) {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this,reportConfigDetaiInfo.name),
        btnAccessCheck:false,
        searchBarProps: {
          dataFormat: (val) => {
            //针对undefind做处理
            val.reportConfigName = null;
            for (var element in val) {
              if(!val[element]){
                val[element] = null
              }
            }
            let params = encodeURIComponent(JSON.stringify(val));
            //搜索参数点击查询会重置掉,需把val对象解构后再次返回
            return {...val,params}
          },
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          bordered: true,
          loading: false,
        },
      },
    },
  };
}

let reduxTemplateCofig = (args) => {
  let {reportConfigId} = args
  const apis = {
    list: {
      path: `${componentName}/getDetailListByPage`,
      payload: {
        key: `${componentName}@getDetailListByPage`,
        apiParams: { pageNum: 1, pageSize: 10,id:reportConfigId },
      },
    },
    export: {
      path: `${componentName}/getDetailListExport`,
      payload: {
        key: `${componentName}@getDetailListExport`,
        apiParams: {id:reportConfigId}
      }
    },
    selectOneById: {
      path: `reportConfig/selectOneById`,
      payload: {
        key: `reportConfig@selectOneById`,
        apiParams: { id : reportConfigId },
      },
    },
    selectOneDetailById: {
      path: `reportConfig/selectOneDetailById`,
      payload: {
        key: `reportConfig@selectOneDetailById`,
        apiParams: { id : reportConfigId },
      },
    },
  };
  return {
    apis,
    componentName,
    initApiKeys: ["list",'selectOneDetailById'],
    keepInitApiParams: true,
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
